import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from "@material-ui/icons/Close";
import { useTranslate } from 'react-admin';
import icInfo from '../../assets/icons/white-information-circle.png';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        borderRadius: 4,
        paddingLeft: 12,
        paddingRight: 8,
        backgroundColor: '#2b3648',
        height: 48,
        alignItems: 'center',
        flexDirection: 'row',
        width: 'fit-content',
        marginLeft: 'auto',
        minWidth: 300,
        marginBottom: theme.spacing(1)
    },
    icInfo: {
        width: 19,
        height: 19,
    },
    text: {
        fontSize: 11,
        color: '#FFFFFF',
        lineHeight: 1.6,
        letterSpacing: 0.5,
        fontFamily: 'UniviaPro-Book',
        marginLeft: 10,
    },
    icClose: {
        width: 12,
        height: 12,
        padding: 4
    },
    close: {
        padding: 4
    },
    closeIcon: {
        color: '#fafefe',
        opacity: 0.7
    },
    buttonUndo: {
        color: '#62bfd5',
        fontSize: 10
    }
}));

const renderHTML = (rawHTML) => React.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });

function Snackbar({ show, undo, message, boldText, onClose }) {
    const classes = useStyles();
    const boldElem = `<span style='font-family: UniviaPro-Bold;'>${boldText}</span>`;
    const translate = useTranslate();

    if (!show) return null;
    return (
        <Box className={classes.container}>
            <Box display="flex" flex={1} alignItems="flex-end">
                <img alt='icInfo' src={icInfo} className={classes.icInfo} />
                <Typography className={classes.text}>{boldText ? renderHTML(message.replace('$1', boldElem)) : message}</Typography>
            </Box>
            <Box display="flex" alignItems="flex-end" style={{ marginLeft: 20 }}>
                {
                    undo && <Button className={classes.buttonUndo} onClick={undo}>{translate(`pos.common.undo`)}</Button>
                }
                <Box style={{ borderLeft: 'solid 1px #e4e5e8' }} >
                    <IconButton
                        aria-label="close"
                        className={classes.close}
                        onClick={onClose}
                    >
                        <CloseIcon className={classes.closeIcon} />
                    </IconButton>
                </Box>
            </Box>
        </Box>
    );
}

Snackbar.propTypes = {
    message: PropTypes.string.isRequired,
    boldText: PropTypes.string,
    undo: PropTypes.func,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default Snackbar;
